import { History } from "history";

import {
  UserProfileDto,
  UpdateUserProfileRequest,
  ChangePasswordRequest,
} from "../../interfaces";

import { MediaDto } from "../../interfaces/media";
import {
  GetUserProfileAction,
  GetUserProfileSuccessAction,
  GetUserProfileErrorAction,
  UpdateUserProfileAction,
  UpdateUserProfileSuccessAction,
  UpdateUserProfileErrorAction,
  UploadUserProfilePhotoAction,
  UploadUserProfilePhotoSuccessAction,
  UploadUserProfilePhotoErrorAction,
  GET_USER_PROFILE,
  GET_USER_PROFILE_ERROR,
  GET_USER_PROFILE_SUCCESS,
  UPDATE_USER_PROFILE,
  UPDATE_USER_PROFILE_ERROR,
  UPDATE_USER_PROFILE_SUCCESS,
  UPLOAD_USER_PROFILE_PHOTO,
  UPLOAD_USER_PROFILE_PHOTO_SUCCESS,
  UPLOAD_USER_PROFILE_PHOTO_ERROR,
  UpdateUserProfileResetAction,
  UPDATE_USER_PROFILE_RESET,
  ChangePasswordAction,
  ChangePasswordSuccessAction,
  ChangePasswordErrorAction,
  ChangePasswordResetAction,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_RESET,
  CHANGE_PASSWORD_SUCCESS,
} from "./actionTypes";

//#region Get User Profile

export const getUserProfile = (): GetUserProfileAction => {
  return {
    type: GET_USER_PROFILE,
    payload: {},
  };
};

export const getUserProfileSuccess = (
  response: UserProfileDto
): GetUserProfileSuccessAction => {
  return {
    type: GET_USER_PROFILE_SUCCESS,
    payload: response,
  };
};

export const getUserProfileError = (error: any): GetUserProfileErrorAction => {
  return {
    type: GET_USER_PROFILE_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update User Profile

export const updateUserProfile = (
  request: UpdateUserProfileRequest,
  history: History
): UpdateUserProfileAction => {
  return {
    type: UPDATE_USER_PROFILE,
    payload: { request, history },
  };
};

export const updateUserProfileSuccess = (
  user: UserProfileDto
): UpdateUserProfileSuccessAction => {
  return {
    type: UPDATE_USER_PROFILE_SUCCESS,
    payload: user,
  };
};

export const updateUserProfileError = (
  error: any
): UpdateUserProfileErrorAction => {
  return {
    type: UPDATE_USER_PROFILE_ERROR,
    payload: error,
  };
};

export const updateUserProfileReset = (): UpdateUserProfileResetAction => {
  return {
    type: UPDATE_USER_PROFILE_RESET,
    payload: null,
  };
};

//#endregion

//#region Upload User Profile Home Image

export const uploadUserProfilePhoto = (
  file: File
): UploadUserProfilePhotoAction => {
  return {
    type: UPLOAD_USER_PROFILE_PHOTO,
    payload: { file },
  };
};

export const uploadUserProfilePhotoSuccess = (
  media: MediaDto
): UploadUserProfilePhotoSuccessAction => {
  return {
    type: UPLOAD_USER_PROFILE_PHOTO_SUCCESS,
    payload: media,
  };
};

export const uploadUserProfilePhotoError = (
  error: any
): UploadUserProfilePhotoErrorAction => {
  return {
    type: UPLOAD_USER_PROFILE_PHOTO_ERROR,
    payload: error,
  };
};

//#endregion

//#region Change Password

export const changePassword = (
  request: ChangePasswordRequest,
  history: History
): ChangePasswordAction => {
  return {
    type: CHANGE_PASSWORD,
    payload: { request, history },
  };
};

export const changePasswordSuccess = (): ChangePasswordSuccessAction => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: null,
  };
};

export const changePasswordError = (error: any): ChangePasswordErrorAction => {
  return {
    type: CHANGE_PASSWORD_ERROR,
    payload: error,
  };
};

export const changePasswordReset = (): ChangePasswordResetAction => {
  return {
    type: CHANGE_PASSWORD_RESET,
    payload: null,
  };
};

//#endregion
